import PropTypes from "prop-types";
import "./StatusIndicators.css";
import AccessibleSpinner from "./AccessibleSpinner";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const Loading = () => (
  <div className="status-loading">
    <AccessibleSpinner size={24} label="Loading data" />
    <span>Loading...</span>
  </div>
);

const ErrorMessage = ({ message = "An error occurred" }) => (
  <div className="status-error">
    <ErrorOutlineIcon color="error" />
    <span>{message}</span>
  </div>
);

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

const StatusIndicators = () => {
  return (
    <div className="status-indicators-container">
      <div className="status-group">
        <div className="status-indicator">
          <div className="status-dot not-enrolled"></div>
          <span className="status-label">Not Enrolled</span>
        </div>
        <div className="status-indicator">
          <div className="status-dot enrolled"></div>
          <span className="status-label">Enrolled</span>
        </div>

        <div className="status-indicator">
          <div className="status-dot declined"></div>
          <span className="status-label">Declined</span>
        </div>
      </div>
    </div>
  );
};

StatusIndicators.Loading = Loading;
StatusIndicators.Error = ErrorMessage;

export default StatusIndicators;
